<template>
  <Content :style="{padding: '0 0 27px 27px'}">
    <div class="stores_title">
      <Breadcrumb>
        <BreadcrumbItem>系统设置</BreadcrumbItem>
        <BreadcrumbItem>用户管理</BreadcrumbItem>
      </Breadcrumb>
      <p>用户管理</p>
    </div>
    <div class="stores_container mt20">
      <div>
        <span>搜索查询：</span>
        <Input v-model="searchValue" placeholder="请输入需要查询的名称" style="width: 300px"></Input>
        <Button class="ml20" type="info">查询</Button>
      </div>
      <div class="mt20">
        <Button type="info" icon="ios-plus-empty" @click="addUser">新建用户</Button>
        <!--<Button type="ghost" class="ml20">导出Excel</Button>-->
        <Button type="default" class="ml10">批量删除</Button>
      </div>
      <Table border ref="selection" :loading="loading" @on-selection-change="checkNum" :columns="userColumns"
             :data="UserData" class="mt20">>
      </Table>
      <div style="margin: 10px;overflow: hidden">
        <div style="float: right;">
          <Page :total="Total" show-total show-sizer show-elevator :current="current" @on-change="changePage"
                @on-page-size-change="changepageSize"></Page>
        </div>
      </div>
    </div>

    <Modal v-model="showChangePw">
      <p slot="header">
        <span>重置密码</span>
      </p>
      <div>
        <Form ref="changePwdData" :model="changePwdData" :rules="changePwdRule" :label-width="80">
          <FormItem label="旧密码" prop="oldpassword">
            <Input v-model="changePwdData.oldpassword" placeholder="请输入新密码" style="width: 300px;"/>
          </FormItem>

          <FormItem label="新密码" prop="newpassword">
            <Input v-model="changePwdData.newpassword" placeholder="请输入新密码" style="width: 300px;"/>
          </FormItem>
        </Form>
      </div>
      <div slot="footer">
        <Button type="primary" @click="resetpassword('changePwdData')">提交</Button>
      </div>
    </Modal>
  </Content>
</template>

<script>
  import config from '@/config.js'
  import md5 from 'js-md5'

  export default {
    name: 'userManagement',
    data() {
      return {
        baseUrl: config('baseServerUrl', '.'),
        searchValue: "",
        current: 1,
        pageSize: 10,
        sort: "",
        Search: "",
        checkNums: 0,
        sels: [],
        loading: true,
        Total: 0,
        showChangePw: false,
        userColumns: [{
          type: 'selection',
          width: 60,
          align: 'center'
        },
          {
            title: '姓名/编号',
            key: 'UserName',
            render: (h, params) => {
              return h('div', [
                h('img', {
                  attrs: {
                    src: params.row.name,
                  },
                  style: {
                    width: '58px',
                    height: '58px',
                    backgroundColor: "#c6cfe1",
                    borderRadius: "29px",
                    margin: "10px 0",
                    float: "left"
                  }
                }),
                // h('Avatar', {
                //   attrs: {
                //     icon: "person",
                //   },
                //   style: {
                //     backgroundColor: "#87d068",
                //     float: "left"
                //   }
                // }),
                h('div', {
                  style: {
                    marginTop: "24px",
                    marginLeft: "70px",
                    fontSize: "16px",
                    color: "rgba(0, 0, 0, 0.85)",
                    position: "absolute"
                  }
                }, (params.row.UserName)),
                // h('div', {
                //   style: {
                //     marginTop: "42px",
                //     marginLeft: "70px",
                //     fontSize: "16px",
                //     position: "absolute",
                //     color: "rgba(67, 67, 67, 0.65)"
                //   }
                // }, ('NO.' + params.row.Id)),
              ])
            }
          },
          {
            title: '角色',
            key: 'RolesFormat',

          },
          {
            title: '电话/手机',
            key: 'Mobile'
          },
          {
            title: '创建日期',
            key: 'CreateTimeFormat'
          },
          {
            title: '操作',
            key: 'operation',
            render: (h, params) => {
              return h('div', [
                h('Button', {
                  props: {
                    type: 'text',
                    size: 'small'
                  },
                  style: {
                    color: '#2db7f5'
                  },
                  on: {
                    click: () => {
                      this.updateUser(params)
                    }
                  }
                }, '编辑'),
                h('Button', {
                  props: {
                    type: 'text',
                    size: 'small'
                  },
                  style: {
                    color: '#2db7f5'
                  },
                  on: {
                    click: () => {
                      this.remove(params)
                    }
                  }
                }, '删除'),

                // h('Button', {
                //   props: {
                //     type: 'text',
                //     size: 'small'
                //   },
                //   style: {
                //     color: '#2db7f5'
                //   },
                //   on: {
                //     click: () => {
                //       this.toChangePwd(params)
                //     }
                //   }
                // }, '重置密码')
              ])
            }
          }
        ],
        UserData: [],
        changePwdData: {
          Id: 0,
          oldpassword: '',
          newpassword: ''
        },
        changePwdRule: {
          oldpassword: [{
            required: true,
            message: '请输入旧密码',
            trigger: 'blur'
          }],
          newpassword: [{
            required: true,
            message: '请输入新密码',
            trigger: 'blur'
          }
            // { type: 'string', min: 6, message: '密码不小于6位数', trigger: 'blur' }
          ]
        }
      }
    },
    created() {
      this.getTableData(
        {
          "page": this.current,
          "size": this.pageSize,
          "sort": this.sort,
          "Search": this.Search
        }
      )
    },
    methods: {
      checkNum(selection) {
        this.checkNums = selection.length
        this.sels = selection
      },
      getTableData(option) {
        let url = this.baseUrl + 'api/auth/userinfo/getlist'
        this.loading = true
        this.$http.post(url, {
          "PageIndex": option.page,
          "PageSize": option.size,
          "SortString": option.sort,
          "SearchString": option.Search
        }).then(res => {
          this.loading = false,
            this.Total = res.data.Data.Total
          this.current = option.page
          this.UserData = lib.filterResult(res.data.Data.DataList || [])
        }).catch(error => {
          this.loading = false
          this.$Message.error('查询失败，' + error.message)
        })
      },
      changePage(page) {
        this.current = page
        this.getTableData(
          {
            "page": this.current,
            "size": this.pageSize,
            "sort": this.sort,
            "Search": this.Search
          }
        )
      },
      changepageSize(size) {
        this.pageSize = size
        this.getTableData(
          {
            "page": this.current,
            "size": this.pageSize,
            "sort": this.sort,
            "Search": this.Search
          }
        )
      },
      // 编辑页面
      updateUser(params) {
        this.$router.push({
          path: 'userDetail',
          query: {
            Id: params.row.Id
          }
        })
      },
      remove(params) {
        this.$Modal.confirm({
          title: '删除',
          content: "确认删除" + params.row.UserName + "吗？",
          okText: '确认',
          cancelText: '取消',
          onOk: () => {
            var delteUrl = this.baseUrl + 'api/userInfo/delete?userid=' + params.row.Id
            this.$http.delete(delteUrl).then(response => {
              this.$Message.info('删除用户成功');
              this.getTableData(
                {
                  "page": this.current,
                  "size": this.pageSize,
                  "sort": this.sort,
                  "Search": this.Search
                }
              )
            }).catch(response => {
              this.$Message.error('删除用户失败，' + response.message);
            })
          },
          onCancel: () => {
            this.$Message.info()
          }
        })
      },
      addUser() {
        this.$router.push({
          name: 'userDetail'
        })
      },
      toChangePwd(params) {
        console.log('params',params)
        this.showChangePw = true
        this.changePwdData = {
          Id: params.row.Id
        }
      },
      resetpassword(name){
        let Url = this.baseUrl + `api/auth/changepassword?oldpassword=${md5(this.changePwdData.oldpassword)}&newpassword=${md5(this.changePwdData.newpassword)}`
        this.$refs[name].validate((valid) => {
          if(valid) {
            this.$http.get(Url).then(response => {
              this.$Message.info('修改密码成功,下次登录生效')
              this.showChangePw = false
            }).catch(response => {
              if(response.message == '密码错误') {
                this.$Message.error('您所填写的旧密码错误！');
              }else{
                this.$Message.error(response.message);
              }
            })
          }
        })
      },
    },

  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/admin/user/userManagement.vue